import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../../../requests";
import { BasicContext } from "../../../../App";
import LoadedRecords from "../../../../components/LoadedRecords";
import ConfirmModal from "../../../../components/modals/ConfirmModal";
import UserPayment from "../../../../components/payments/UserPayment";

const UserDetailsTransactions = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, showView, NOR, setAlerts } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [displayNOR, setDisplayNOR] = useState(NOR);
    const [showCancelPaymentModal, setShowCancelPaymentModal] = useState(false);

    const getPaymentsList = async () => {
        const res = await postMethod("/payments-list", { userID: showView.params.userID });
        if (checkServerData(res)) {
            setList(res.data.list);
        }
        setLoading(false);
    };

    const cancelPaymentForPass = async (up) => {
        const res = await postMethod("/cancel-payment-for-pass", { up: up });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "cancelled" }]);
            setLoading(true);
            setTimeout(() => {
                getPaymentsList();
            }, 200);
        }
    };

    useEffect(() => {
        getPaymentsList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Container>
                <Row>
                    {loading ? (
                        <Col className="text-center">
                            <FontAwesomeIcon icon={faSpinner} className="rotate-center" />
                        </Col>
                    ) : (
                        <Fragment>
                            <Col xs={12} className="px-4">
                                <p className="h6 mb-3">{t("transactions.transactions")}</p>
                            </Col>

                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table">
                                            <tbody>
                                                {list
                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <UserPayment p={e} showActions onShowCancelPaymentModal={setShowCancelPaymentModal} />
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Fragment>
                    )}
                </Row>
            </Container>
            {showCancelPaymentModal && (
                <ConfirmModal
                    onClose={() => setShowCancelPaymentModal(false)}
                    show={true}
                    text={t("cancelPaymentModal.text", { passName: showCancelPaymentModal.pass_name, orderNumber: showCancelPaymentModal.order_number })}
                    proceedTxt={t("cancelPaymentModal.proceedTxt")}
                    cancelTxt={t("cancelPaymentModal.cancelTxt")}
                    onProceed={() => {
                        setShowCancelPaymentModal(false);
                        cancelPaymentForPass(showCancelPaymentModal);
                    }}
                    title={t("cancelPaymentModal.title")}
                />
            )}
        </Fragment>
    );
};

export default UserDetailsTransactions;
